<app-loading-generico [loadingGenerico]="loadingGenerico"></app-loading-generico>

<div class="container py-4">

  <!-- CONTEÚDO -->
  <div class="row">

    @if (erro === true) {
      <div class="text-center">
        <img src="/assets/img/erro.png" width="200px" alt="Erro">
        <p class="legenda-erro">Ocorreu um erro na consulta dos endereços.</p>
      </div>
    }

    @if (erro === false) {
      <div class="col-lg-12 mb-4 mb-lg-0">
        <div class="row">
          <div class="col-lg-8"></div>
          <div class="col-lg-4">
            <div class="input-group align-items-center">
              <input type="text" class="form-control sombra" placeholder="Buscar" [(ngModel)]="term "
                (keyup)="searchUserFilter()" (clickOutside)="clickOutside()">
              <i class="fa fa-search c-gray icone-lupa" aria-hidden="true"></i>
            </div>
          </div>
          <div class="col-12">
            <!-- TABELA -->
            <table class="table table-hover border-bottom mt-4" aria-describedby="table que lista os enderecos">
              <thead>
                <tr>
                  <th scope="col">
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" id="provisorio"
                        name="provisorio" title="provisorio" [checked]='checkAll'
                        (click)="selectAll($event)"
                        (keydown)="selectAll($event)">
                      <label class="form-check-label" for="provisorio"> </label>
                    </div>
                  </th>
                  <th scope="col" class="upper">logradouro</th>
                  <th scope="col" class="upper">cep</th>
                  <th scope="col" class="upper">Complemento</th>
                  <th scope="col" class="upper">bairro</th>
                  <th scope="col" class="upper">Cidade</th>
                  <th scope="col" class="upper">Estado</th>
                </tr>
              </thead>
              <tbody>
                <!-- filter:term | paginate: { id: 'empresas', itemsPerPage: itemsPerPage , currentPage: currentPage, totalItems: totalItems}" -->
                @for (end of enderecoListFiltrado |  paginate: { id: 'enderecos', itemsPerPage: itemsPerPage , currentPage: currentPage, totalItems: totalItems}; track end) {
                  <tr
                    >
                    <td>
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input"
                          id="checkbox-{{end.idEndereco}}"
                          name="{{end.idEndereco}}"
                          title="{{end.idEndereco}}"
                          (click)="onTableAddressClick(end.idEndereco)"
                          (keydown)="onTableAddressClick(end.idEndereco)"
                          [checked]="isChecked(end.idEndereco)"
                          [attr.aria-label]="'Selecionar endereço ' + end.idEndereco">
                        <label class="form-check-label" for="checkbox-{{end.idEndereco}}"></label>
                      </div>
                    </td>
                    <td>{{end.descricaoLogradouro}}</td>
                    <td>{{end.codigoCep}}</td>
                    <td>{{end.codigoComplemento}}</td>
                    <td>{{end.codigoBairro}}</td>
                    <td>{{end.codigoCidade}}</td>
                    <td>{{end.codigoEstado}}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
        <div class="text-center mb-5 mt-3">
          <button type="button" class="btn-borda-verde bnt-font btn-grande-verde" (click)='salvar()'>SALVAR</button>
        </div>
        <hr>
          <div class="row mt-5 ">
            <div class="col-3 mb-4 me-3">
              <app-select
                [value]="itemsPerPage"
                (valueChanges)="itemsPerPage = $event"
                name="itemsPerPageName"
                    [options]="[
                    {name : 'Exibir 5 Ruas' , value : '5'} , 
                    {name : 'Exibir 10 Ruas' , value : '10'} ,
                    {name : 'Exibir 15 Ruas' , value : '15'} ,
                    {name : 'Exibir 20 Ruas' , value : '20'}

                    ]"
                optionValue="value"
                optionText="name">
              </app-select>
            </div>
            <div class="col-auto mb-4 text-center ps-0 me-5">
              <pagination-controls class="bg-danger ps-0" id="enderecos" (pageChange)="getPage($event)"
                (pageBoundsCorrection)="pageChanged($event)" directionLinks="true" autoHide="true"
                responsive="true" previousLabel="Anterior" nextLabel="Próximo"
                screenReaderPaginationLabel="Pagination" screenReaderPageLabel="page"
                screenReaderCurrentLabel="Página">
              </pagination-controls>
            </div>
            <div class="col-auto"></div>
            <p class="texto-tabela text-nowrap text-end"><span>{{totalItemsExiba}}</span>
          Registros foram encontrados</p>
        </div>
      </div>
    }
  </div>
</div>